module.exports = __webpack_public_path__ + "static/media/mobile_large_banner.0f348ea0.jpg";